import { Component, OnDestroy, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { LoadingService } from "src/app/services/loading.service";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SuiteShellService } from '@services/suite-shell.service';

@Component({
    selector: 'app-private-layout',
    templateUrl: './private-layout.component.html',
    styleUrls: ['./private-layout.component.scss'],
    standalone: false
})
export class PrivateLayoutComponent implements OnInit, OnDestroy {
  @BlockUI('componentsPrivateLayout') blockUIglobal: NgBlockUI;
  header = "Mis Solicitudes";
  dataSession = null;
  isPortalClienteRoute = false;
  /**
   * Sidebar global de la suite. Solo en la cara suite, y fuera del portal
   * de contrapartes y de las pantallas públicas.
   */
  showSuiteSidebar = false;
  /** Como el de la clásica: dura mientras se navega y vuelve a abierto al recargar. */
  menuColapsado = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    public _loading: LoadingService,
    private router: Router,
    private shell: SuiteShellService,
  ) { }

  ngOnInit() {
    this._loading.setLoadingUI(this.blockUIglobal);
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(() => this.updateRouteFlags());
    this.shell.cara$.pipe(takeUntil(this.destroy$)).subscribe(() => this.updateRouteFlags());
    this.updateRouteFlags();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateRouteFlags() {
    const url = this.router.url;
    this.isPortalClienteRoute = url.startsWith('/portal-cliente');
    const sinSidebar = ['/portal-cliente', '/intro', '/login', '/change-password', '/logout'];
    const rutaSinSidebar = sinSidebar.some((p) => url.startsWith(p));
    this.showSuiteSidebar = this.shell.cara === 'suite' && !rutaSinSidebar;
  }

  alternarMenu(): void {
    this.menuColapsado = !this.menuColapsado;
  }

  getDataSession(data) {
    this.dataSession = data;
  }
}
